import * as React from "react";
import {NewsCategory} from "../../../../../../model/NewsCategory";
import TrendingArticlesList from "../TrendingArticlesList/TrendingArticlesList";

interface TrendingCategories {
    categories: NewsCategory[],
}

const TrendingArticlesCategory: React.FC<TrendingCategories> = (props) => (
    <React.Fragment>
        {
            props.categories.map((newsCategory, index) => {
                return (
                    <React.Fragment key={index}>
                        <div className="row w-100">
                            <span className="trending-section-insert-title p-1">{newsCategory.category}</span>
                        </div>
                        <TrendingArticlesList trending={newsCategory.items} />
                    </React.Fragment>
                )
            })
        }
    </React.Fragment>
)

export default TrendingArticlesCategory;